import axios from 'axios';
import { serviceUrl } from '../config';
import { getSession } from '../App';

export const read_artifacts = async (sessionid, artifactObj, simType) => {
    const localsid = getSession();
    try {
        return await axios.put(serviceUrl + simType + '/read/' + (localsid != undefined ? sessionid : ''), artifactObj);
    } catch (error) {
        return Promise.reject(error.response)
    }
}